// @generated by protoc-gen-es v1.9.0 with parameter "target=ts"
// @generated from file no/jotta/openapi/language.proto (package no.jotta.openapi, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { EnumValueOptions, proto3 } from "@bufbuild/protobuf";
/**
 * @generated from enum no.jotta.openapi.Language
 */
export var Language;
(function (Language) {
    /**
     * @generated from enum value: UNKNOWN_LANGUAGE = 0;
     */
    Language[Language["UNKNOWN_LANGUAGE"] = 0] = "UNKNOWN_LANGUAGE";
    /**
     * @generated from enum value: ENGLISH = 1;
     */
    Language[Language["ENGLISH"] = 1] = "ENGLISH";
    /**
     * @generated from enum value: NORWEGIAN = 2;
     */
    Language[Language["NORWEGIAN"] = 2] = "NORWEGIAN";
    /**
     * @generated from enum value: SWEDISH = 3;
     */
    Language[Language["SWEDISH"] = 3] = "SWEDISH";
    /**
     * @generated from enum value: DANISH = 4;
     */
    Language[Language["DANISH"] = 4] = "DANISH";
    /**
     * @generated from enum value: FINNISH = 5;
     */
    Language[Language["FINNISH"] = 5] = "FINNISH";
    /**
     * @generated from enum value: FRENCH = 6;
     */
    Language[Language["FRENCH"] = 6] = "FRENCH";
    /**
     * @generated from enum value: GERMAN = 7;
     */
    Language[Language["GERMAN"] = 7] = "GERMAN";
    /**
     * @generated from enum value: DUTCH = 8;
     */
    Language[Language["DUTCH"] = 8] = "DUTCH";
    /**
     * @generated from enum value: SPANISH = 9;
     */
    Language[Language["SPANISH"] = 9] = "SPANISH";
    /**
     * @generated from enum value: CATALAN = 10;
     */
    Language[Language["CATALAN"] = 10] = "CATALAN";
    /**
     * @generated from enum value: PORTUGUESE = 11;
     */
    Language[Language["PORTUGUESE"] = 11] = "PORTUGUESE";
    /**
     * @generated from enum value: POLISH = 12;
     */
    Language[Language["POLISH"] = 12] = "POLISH";
})(Language || (Language = {}));
// Retrieve enum metadata with: proto3.getEnumType(Language)
proto3.util.setEnumType(Language, "no.jotta.openapi.Language", [
    { no: 0, name: "UNKNOWN_LANGUAGE" },
    { no: 1, name: "ENGLISH" },
    { no: 2, name: "NORWEGIAN" },
    { no: 3, name: "SWEDISH" },
    { no: 4, name: "DANISH" },
    { no: 5, name: "FINNISH" },
    { no: 6, name: "FRENCH" },
    { no: 7, name: "GERMAN" },
    { no: 8, name: "DUTCH" },
    { no: 9, name: "SPANISH" },
    { no: 10, name: "CATALAN" },
    { no: 11, name: "PORTUGUESE" },
    { no: 12, name: "POLISH" },
]);
/**
 * @generated from extension: string language_code = 62295727;
 */
export const language_code = proto3.makeExtension("no.jotta.openapi.language_code", EnumValueOptions, { no: 62295727, kind: "scalar", T: 9 /* ScalarType.STRING */ });
